import React, { useContext, useEffect, useState } from 'react'
import { Button, Form, Input } from 'antd'
import { AppContext } from 'AppContext'
import client from 'apollo'
import {
  SEND_OTP_FOR_REEVALUATE,
  UPDATE_USER,
  VERIFY_OTP_FOR_REEVALUATE,
} from 'modules/Users/graphql/Mutations'
import openNotification from 'utils/Notification'
import { useHistory } from 'react-router-dom'

import './Reevalute.css'
import CustomMeta from 'components/CustomMeta'

const OTP_EXPIRY_KEY = 'otp_expiry_time'
const OTP_SENT_KEY = 'otp_sent_once'

const New = () => {
  const history = useHistory()
  const [loaded, setLoaded] = useState(false)
  const [loader, setLoader] = useState(false)
  const [otp, setOtp] = useState()
  const [secondsLeft, setSecondsLeft] = useState(0)
  const [hasSentOnce, setHasSentOnce] = useState(false)

  const {
    state: { currentUser, isMobile },
    dispatch,
  } = useContext(AppContext)

  const sendOTP = () => {
    setLoaded(true)
    const now = new Date()

    client
      .mutate({ mutation: SEND_OTP_FOR_REEVALUATE })
      .then((res) => {
        const message = res?.data?.sendOtpForReEvaluate?.message

        let coolDown = 180
        if (message?.includes('Please try after')) {
          const secondsMatch = message.match(/\d+/)
          coolDown = secondsMatch ? parseInt(secondsMatch[0]) : 180
          openNotification('error', message)
        } else {
          openNotification('success', message)
        }

        const expiry = new Date(now.getTime() + coolDown * 1000)
        localStorage.setItem(OTP_EXPIRY_KEY, expiry.toISOString())
        localStorage.setItem(OTP_SENT_KEY, 'true')
        setSecondsLeft(coolDown)
      })
      .catch((err) => {
        console.error(err)
        openNotification('error', 'Failed to send OTP')
      })
      .finally(() => setLoaded(false))
  }

  useEffect(() => {
    const expiryStr = localStorage.getItem(OTP_EXPIRY_KEY)
    const hasSent = localStorage.getItem(OTP_SENT_KEY) === 'true'
    setHasSentOnce(hasSent)

    const now = new Date()
    const expiry = expiryStr ? new Date(expiryStr) : null
    const diff = expiry ? Math.floor((expiry - now) / 1000) : 0

    if (expiryStr && !isNaN(diff) && diff > 0) {
      setSecondsLeft(diff)
    } else {
      setSecondsLeft(0)
    }
  }, [])

  useEffect(() => {
    if (secondsLeft <= 0) return

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        const updated = prev - 1
        if (updated <= 0) {
          clearInterval(interval)
          localStorage.removeItem(OTP_EXPIRY_KEY)
        }
        return updated
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [secondsLeft])

  const onFinish = (value) => {
    setLoader(true)
    client
      .mutate({
        mutation: VERIFY_OTP_FOR_REEVALUATE,
        variables: { otp: value.otp },
      })
      .then((res) => {
        if (res.data.verifyOtpForReEvaluate) {
          localStorage.removeItem(OTP_EXPIRY_KEY)
          localStorage.removeItem(OTP_SENT_KEY)

          client
            .mutate({
              mutation: UPDATE_USER,
              variables: {
                data: {
                  reEvaluate: true,
                  completedSteps: 'LOGIN_CREATED',
                  isNewAuaAdvisoryGenerate: false,
                  token: null,
                  tokenExpiration: null,
                },
                id: parseInt(currentUser.id),
              },
            })
            .then((res) => {
              dispatch({ type: 'CURRENT_USER', data: res.data.updateUser })
              dispatch({ type: 'IS_VERIFICATION_DONE', data: false })
              history.push('/verification')
            })
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoader(false))
  }

  return (
    <>
      <CustomMeta title='Re-Evaluate' />
      <div className='re_evaluate_main_div'>
        <h1 className='re_evaluate_text'>Re-evaluate Risk Profile</h1>
        <div className='re_evaluate_form'>
          <Form
            onFinish={onFinish}
            initialValues={{
              email: currentUser.email,
              phone: currentUser.phone,
            }}
            layout='vertical'
            className='client-detail-form'
          >
            <div className='re_evaluate_form_field_div'>
              <Form.Item
                name='email'
                label='Registered Email ID'
                rules={[{ required: true }]}
                style={isMobile ? {} : { width: '375px' }}
              >
                <Input
                  className='client-detail-input'
                  placeholder='Enter email'
                  disabled
                />
              </Form.Item>
              <Form.Item
                name='phone'
                label='Registered Mobile Number'
                rules={[{ required: true }]}
                style={isMobile ? {} : { width: '375px' }}
              >
                <Input
                  type='number'
                  placeholder='Enter Mobile Number'
                  disabled
                />
              </Form.Item>
              <Form.Item>
                {secondsLeft > 0 ? (
                  <span style={{ color: '#af0000' }}>
                    Try again in {Math.floor(secondsLeft / 60)}m{' '}
                    {secondsLeft % 60}s
                  </span>
                ) : (
                  <Button
                    className='submit_btn'
                    type='primary'
                    onClick={sendOTP}
                    loading={loaded}
                  >
                    {hasSentOnce ? 'Resend OTP' : 'Send OTP'}
                  </Button>
                )}
              </Form.Item>
            </div>
            <div className='re_evaluate_divider' />
            <div className='otp_form_div'>
              <Form.Item
                name='otp'
                label='OTP'
                rules={[{ required: true }]}
                style={isMobile ? {} : { width: '375px' }}
              >
                <Input
                  className='client-detail-input'
                  placeholder='Enter OTP'
                  type='number'
                  onChange={(e) => setOtp(e.target.value)}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  className='submit_btn'
                  disabled={!otp?.length}
                  type='primary'
                  htmlType='submit'
                  loading={loader}
                >
                  Submit
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </>
  )
}

export default New
